export enum Multimedia {
	Image = "image",
	Video = "video"
}
